// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2634":"2c796e83","2937":"eabe11fc","4838":"33d91445"}[chunkId] || chunkId) + "." + {"217":"2afd8e088730cfbc","1167":"ec6975b3361e87c8","2072":"7877769c2d57d310","2634":"8e74a830d6389bd9","2937":"e4ecc13838fc5435","4838":"6299817856658795","5194":"1b9e468a3fa7558e"}[chunkId] + ".js";
};